import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  section: {
    marginBottom: theme.spacing(4),
  },
  sectionTitle: {
    fontWeight: 700,
    fontSize: 13,
    letterSpacing: 1,
    textTransform: 'uppercase',
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(2),
  },
  thumbnail: {
    width: '100%',
    height: 200,
    objectFit: 'cover',
    borderRadius: theme.shape.borderRadius,
    border: `1px dashed ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.default,
    [theme.breakpoints.up('sm')]: {
      width: 320,
    },
  },
  thumbnailPlaceholder: {
    width: '100%',
    height: 200,
    borderRadius: theme.shape.borderRadius,
    border: `1px dashed ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.default,
    [theme.breakpoints.up('sm')]: {
      width: 320,
    },
  },
  lessonRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.5, 2),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    marginBottom: theme.spacing(1),
  },
  lessonTitle: {
    flexGrow: 1,
    fontSize: 14,
    color: theme.palette.text.primary,
    wordBreak: 'break-word',
    overflowWrap: 'anywhere',
  },
  lessonIcon: {
    color: theme.palette.text.secondary,
    fontSize: 20,
  },
  lessonsLabel: {
    fontWeight: 600,
    fontSize: 13,
    color: theme.palette.text.primary,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  accordion: {
    marginBottom: theme.spacing(1),
    '&:before': {
      display: 'none',
    },
  },
  accordionSummary: {
    fontWeight: 600,
    wordBreak: 'break-word',
    overflowWrap: 'anywhere',
  },
  accordionDetails: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    paddingTop: theme.spacing(1),
  },
}))

export default useStyles
